import { useCallback, useEffect, useMemo, useState } from 'react';
import BaseService from '../../../../../services/BaseService';
import {
  mergeNsmpResumos,
  mergeParticipacaoContext,
} from '../utils/mergeNsmpResumos';

const digitacaoContextUrl = (nsirId) => `nsirs/${nsirId}/mtbt/digitacao-context`;
const participacaoUrl = (nsirId) => `nsirs/${nsirId}/mtbt/participacao`;

export const useMtBtDigitacaoContext = (nsirId, nsmps) => {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchFailed, setFetchFailed] = useState(false);

  const fetchContext = useCallback(async () => {
    if (!nsirId) {
      setContext(null);
      setFetchFailed(false);
      return;
    }

    setLoading(true);
    setFetchFailed(false);

    try {
      const response = await BaseService.get({ url: digitacaoContextUrl(nsirId) });
      let data = response?.data || null;

      if (data?.participacaoUsuario?.mode === 'CONSULTA') {
        try {
          const participacaoResponse = await BaseService.get({ url: participacaoUrl(nsirId) });
          data = mergeParticipacaoContext(data, participacaoResponse?.data);
        } catch {
          // D5 ausente ou erro — mantém D3
        }
      }

      setContext(data);
    } catch {
      setContext(null);
      setFetchFailed(true);
    } finally {
      setLoading(false);
    }
  }, [nsirId]);

  useEffect(() => {
    fetchContext();
  }, [fetchContext]);

  const enrichedNsmps = useMemo(
    () => mergeNsmpResumos(nsmps, context?.nsmpResumos),
    [nsmps, context?.nsmpResumos],
  );

  return {
    context,
    enrichedNsmps,
    loading,
    fetchFailed,
    refetch: fetchContext,
  };
};

export default useMtBtDigitacaoContext;
